import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { socialConfig } from './socialConfig';

const Footer = () => {
  const [socials, setSocials] = useState([]);

  useEffect(() => {
    const fetchSocials = async () => {
      try {
        const q = query(collection(db, "socialLinks"), orderBy("name"));
        const querySnapshot = await getDocs(q);
        setSocials(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (error) {
        console.error("ফুটারে সোশ্যাল লিংক আনতে সমস্যা হয়েছে:", error);
      }
    };

    fetchSocials();
  }, []);

  // প্রতিটি ক্যাটাগরি থেকে প্রথম পাওয়া লিংকটি ফিল্টার করে নেওয়া
  const mainFacebook = socials.find(s => s.category?.trim() === 'ফেসবুক পেজ');
  const mainYoutube = socials.find(s => s.category?.trim() === 'ইউটিউব চ্যানেল');
  const mainTiktok = socials.find(s => s.category?.trim() === 'টিকটক');
  const mainTwitter = socials.find(s => s.category?.trim() === 'টুইটার');
  const mainInstagram = socials.find(s => s.category?.trim() === 'ইনস্টাগ্রাম');
  const mainWhatsapp = socials.find(s => s.category?.trim() === 'হোয়াটসঅ্যাপ');

  const selectedSocials = [
    mainFacebook, 
    mainYoutube, 
    mainTiktok, 
    mainTwitter, 
    mainInstagram, 
    mainWhatsapp
  ].filter(Boolean);

  return (
    <footer style={{ 
      backgroundColor: '#ffffff',
      color: '#333333',
      padding: '30px 20px',
      marginTop: '40px',
      borderTop: '1px solid #d2202a',
      fontFamily: 'sans-serif'
    }}>
      <div style={{ 
        display: 'flex', 
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: '20px',
        maxWidth: '1200px',
        margin: '0 auto' 
      }}>
        
        {/* সেকশন ১: সম্পাদক ও প্রকাশক */}
        <div style={{ flex: '1 1 250px' }}>
          <p style={{ fontSize: '15px', lineHeight: '1.8', margin: '0' }}>
            <span style={{ fontWeight: 'bold' }}>সম্পাদক: মুনতাসির রাসেল</span> <br />
            <span style={{ fontWeight: 'bold' }}>প্রকাশক: এরশাদুল করিম রাজু</span> <br />
            উপদেষ্টা আবু রায়হান, প্রতিষ্ঠাতা পন্ডিত সাংস্কৃতিক কেন্দ্র
          </p>
        </div>

        {/* সেকশন ২: কার্যালয় */}
        <div style={{ flex: '1 1 250px' }}>
          <p style={{ fontSize: '15px', lineHeight: '1.8', margin: '0' }}>
            <span style={{ fontWeight: 'bold' }}>কার্যালয়:</span> এল.এস.ডি. মোড়, চিলমারী, কুড়িগ্রাম
          </p>
        </div>

        {/* সেকশন ৩: মোবাইল ও ই-মেইল */}
        <div style={{ flex: '1 1 250px' }}>
          <p style={{ fontSize: '15px', lineHeight: '1.8', margin: '0' }}>
            <span style={{ fontWeight: 'bold' }}>মোবাইল:</span> ০১৭১৪২৪১৭৬৪ <br />
            <span style={{ fontWeight: 'bold' }}>ই-মেইল:</span> vawaiyaexpress@gmail.com
          </p>
        </div>

        {/* সেকশন ৪: সবসময় রঙিন ব্যাকগ্রাউন্ড এবং হোভাসে শুধু নড়াচড়া (Hover Animation) */}
        <div style={{ flex: '1 1 200px' }}>
          <p style={{ fontWeight: 'bold', fontSize: '16px', margin: '0 0 10px 0' }}>সোশ্যাল মিডিয়া</p>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            {selectedSocials.map(s => {
              const cleanCategory = s.category ? s.category.trim() : '';
              const social = socialConfig[cleanCategory] || socialConfig['অন্যান্য'];
              const IconComponent = social?.icon;
              const brandColor = social?.color || '#333';

              return (
                <a 
                  key={s.id} 
                  href={s.url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title={s.name}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '38px',
                    height: '38px',
                    backgroundColor: brandColor, // ব্যাকগ্রাউন্ড সবসময়ই ব্র্যান্ড কালার দিয়ে রঙিন থাকবে
                    color: '#ffffff',             // আইকন সবসময় সাদা থাকবে
                    borderRadius: '50%',
                    textDecoration: 'none',
                    fontSize: '16px',
                    transition: 'all 0.3s ease-in-out',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)'; // মাউস নিলে শুধু উপরে একটু উঠবে (নড়াচড়া করবে)
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  {IconComponent && <IconComponent />}
                </a>
              );
            })}
          </div>
        </div>

      </div>

      {/* কপিরাইট ও ডেভেলপার */}
      <div style={{ 
        textAlign: 'center', 
        marginTop: '30px', 
        fontSize: '14px',
        color: '#666'
      }}>
        <hr style={{ border: 'none', borderTop: '1px solid #eaeaea', marginBottom: '15px' }} />
        স্বত্ব © ২০২৬ সর্বস্বত্ব সংরক্ষিত। <br />
        Designed & Developed by <span style={{ fontWeight: 'bold', color: '#333' }}>Maruf Billah</span> <br />
        Mobile: 01521478993 (WhatsApp)
      </div>
    </footer>
  );
};

export default Footer;